const getFileEnding = (file) => {
    if (file && file.name.indexOf('.') >= 0) {
        const fileSplit = file.name.split('.');
        return `.${fileSplit[fileSplit.length - 1]}`;
    }
    return '';
};
export default getFileEnding;
